import fetch from "auth/FetchInterceptor";
import JwtAuthService from "./JwtAuthService";
import { useDispatch } from "react-redux";
import { signOut, updateCredit } from "../redux/actions";

const UserService = {};
const serviceBase = "/user";

UserService.getAdmins = function () {
  return {
    queryKey: ['get_all_admins'],
    queryFn: () => fetch({
      url: serviceBase + "/getAllAdmins",
      method: "GET",
    })
  };
};


UserService.changePassword = function (params) {
  return fetch({
    url: serviceBase + "/password",
    method: "Post",
    data: params,
  });
};

UserService.startMeeting = function (params) {
  return fetch({
    url: serviceBase + "/addMeeting",
    method: "Post",
    data: params,
  });
};

UserService.StopMeeting = function (params) {
  return fetch({
    url: serviceBase + "/stopMeeting",
    method: "Get",
  });
};

UserService.block = function (params) {
  return fetch({
    url: serviceBase + "/block",
    method: "Post",
    data: params,
  });
};

UserService.modify = function (params) {
  return fetch({
    url: serviceBase + "/modify",
    method: "Post",
    data: params,
  });
};

UserService.getDashboard = function (data) {
  return fetch({
    url: serviceBase + "/adminDashboard",
    method: "Post",
    data: data
  });
}

UserService.getGoals = function (data) {
  return fetch({
    url: serviceBase + "/monthlyGoals",
    method: "Post",
    data: data
  });
}


UserService.getUsersByRole = function () {
  return fetch({
    url: serviceBase + "/getAll",
    method: "Get",
  });
};

UserService.getClients = function (params) {
  return {
    queryKey: ['users', params],
    queryFn: () => fetch({
      url: serviceBase + "/getClients",
      method: "post",
      data: {
        ...params,
      },
    })
  }
};
UserService.ValidateCin = function (data) {
  return fetch({
    url: "/validateCin",
    method: "post",
    data: data,
  });
};

UserService.addUser = function (data) {
  return fetch({
    url: serviceBase + "/addAdmin",
    method: "post",
    data: data,
  });
};

UserService.ModifyUser = function (data) {
  return fetch({
    url: serviceBase + "/subUserPassword",
    method: "post",
    data: data,
  });
};

UserService.addTransaction = function (data) {
  return fetch({
    url: "/transaction/add",
    method: "post",
    data: data,
  });
};

UserService.getTransactionTo = function (data) {
  return fetch({
    url: "/transaction/getAllWithUser/" + parseInt(data),
    method: "get",
  });
};

UserService.getUserByCode = function (data) {
  return fetch({
    url: serviceBase + "/getUserByCode/" + data,
    method: "get",
  });
};

UserService.deleteAdmin = function (data) {
  return fetch({
    url: serviceBase + "/deleteAdmin",
    method: "post",
    data: data,
  });
};

UserService.getAdminActivity = function (adminId) {
  return fetch({
    url: serviceBase + "/adminActivity/" + adminId,
    method: "get",
  });
};

UserService.updateAdminPermissions = function (data) {
  return fetch({
    url: serviceBase + "/updatePermissions",
    method: "post",
    data: data,
  });
};

UserService.getAdminStats = function () {
  return fetch({
    url: serviceBase + "/adminStats",
    method: "get",
  });
};

UserService.getAdmin = function (id) {
  return {
    queryKey: ['get_admin', id],
    queryFn: () => fetch({
      url: serviceBase + "/getAdmin/" + id,
      method: "get",
    })
  };
};

UserService.getActionLogs = function (data) {
  return fetch({
    url: serviceBase + "/actionLogs",
    method: "post",
    data: data,
  });
};

UserService.changeLevel = function (data) {
  return fetch({
    url: serviceBase + "/changeLevel",
    method: "post",
    data: data,
  });
};

UserService.changeParent = function (data) {
  return fetch({
    url: serviceBase + "/changeParent",
    method: "post",
    data: data,
  });
};

UserService.getProfile = function (params) {
  return {
    queryKey: ['user_profile', params],
    queryFn: () => fetch({
      url: serviceBase + "/getProfile",
      method: "post",
      data: params,
    })
  };
};

export default UserService;
